import type { Application, SavedOpportunity } from '../types/search';

export const applications: Application[] = [
  {
    id: 'app-1',
    reference: 'APP-2026-1841',
    opportunityId: 'opp-1',
    candidateProfileId: 'cand-1',
    status: 'interview_stage',
    submittedAt: '2026-08-19T14:05:00Z',
    resumeDocumentId: 'doc-1',
    screeningAnswers: [
      {
        questionId: 'q1',
        answer:
          'I led the standardization of clinical support services across four hospitals following two acquisitions. We consolidated scheduling, sterile processing and patient transport onto one operating model over fourteen months. Throughput improved measurably at three of the four sites and held flat at the fourth. We abandoned the plan to consolidate pharmacy operations after the clinical leadership at two sites demonstrated the local variation was clinically justified rather than habitual.',
      },
      { questionId: 'q2', answer: 'Yes' },
      { questionId: 'q3', answer: 'Yes, already located there' },
    ],
    compensationAlignmentConfirmed: true,
    locationAlignmentConfirmed: true,
    internalReviewConsentAt: '2026-08-19T14:04:00Z',
    events: [
      {
        id: 'ev-1-1',
        status: 'submitted',
        occurredAt: '2026-08-19T14:05:00Z',
        actorUserId: 'user-cand-1',
        actorRoleLabel: 'Candidate',
        note: 'Application submitted with executive résumé and screening responses. Reference APP-2026-1841 issued.',
        candidateVisible: true,
      },
      {
        id: 'ev-1-2',
        status: 'under_preliminary_review',
        occurredAt: '2026-08-20T09:12:00Z',
        actorUserId: 'user-rec-1',
        actorRoleLabel: 'Recruiter',
        note: 'Preliminary review opened by the mandate owner.',
        candidateVisible: true,
      },
      {
        id: 'ev-1-3',
        status: 'search_team_review',
        occurredAt: '2026-08-22T11:40:00Z',
        actorUserId: 'user-rec-1',
        actorRoleLabel: 'Recruiter',
        note: 'Advanced to search-team review following a structured first conversation on 21 August.',
        candidateVisible: true,
      },
      {
        id: 'ev-1-4',
        status: 'candidate_consent_required',
        occurredAt: '2026-08-25T10:00:00Z',
        actorUserId: 'user-rec-1',
        actorRoleLabel: 'Recruiter',
        note: 'Presentation authorization requested, naming the client organization.',
        candidateVisible: true,
      },
      {
        id: 'ev-1-5',
        status: 'presented_to_client',
        occurredAt: '2026-08-26T09:00:00Z',
        actorUserId: 'user-rec-1',
        actorRoleLabel: 'Recruiter',
        note: 'Profile and written assessment presented to the client following recorded authorization.',
        candidateVisible: true,
      },
      {
        id: 'ev-1-6',
        status: 'client_review',
        occurredAt: '2026-08-27T15:30:00Z',
        actorUserId: 'user-rec-1',
        actorRoleLabel: 'Recruiter',
        note: 'Client reviewing the shortlist submission.',
        candidateVisible: true,
      },
      {
        id: 'ev-1-7',
        status: 'interview_stage',
        occurredAt: '2026-08-28T10:15:00Z',
        actorUserId: 'user-rec-1',
        actorRoleLabel: 'Recruiter',
        note: 'First client interview requested. Availability confirmed for 9 September.',
        candidateVisible: true,
      },
    ],
    createdAt: '2026-08-19T13:40:00Z',
    updatedAt: '2026-08-28T10:15:00Z',
  },
  {
    id: 'app-2',
    reference: 'APP-2026-1863',
    opportunityId: 'opp-2',
    candidateProfileId: 'cand-2',
    status: 'candidate_consent_required',
    submittedAt: '2026-08-24T16:40:00Z',
    resumeDocumentId: 'doc-5',
    screeningAnswers: [
      {
        questionId: 'q1',
        answer:
          'I owned the reporting modernization at my current employer, moving from a spreadsheet-led consolidation across eleven entities to a single system with a five-day close. Reporting quality issues raised by the auditor in the prior two years were closed out.',
      },
      { questionId: 'q2', answer: 'No' },
      { questionId: 'q3', answer: 'Yes' },
    ],
    compensationAlignmentConfirmed: true,
    locationAlignmentConfirmed: true,
    internalReviewConsentAt: '2026-08-24T16:39:00Z',
    events: [
      {
        id: 'ev-2-1',
        status: 'submitted',
        occurredAt: '2026-08-24T16:40:00Z',
        actorUserId: 'user-cand-2',
        actorRoleLabel: 'Candidate',
        note: 'Application submitted. Reference APP-2026-1863 issued.',
        candidateVisible: true,
      },
      {
        id: 'ev-2-2',
        status: 'under_preliminary_review',
        occurredAt: '2026-08-26T08:50:00Z',
        actorUserId: 'user-rec-1',
        actorRoleLabel: 'Recruiter',
        note: 'Preliminary review opened.',
        candidateVisible: true,
      },
      {
        id: 'ev-2-3',
        status: 'additional_information_requested',
        occurredAt: '2026-08-27T13:20:00Z',
        actorUserId: 'user-rec-1',
        actorRoleLabel: 'Recruiter',
        note: 'Executive résumé requested in an updated form. See the document centre for the specific feedback.',
        candidateVisible: true,
      },
      {
        id: 'ev-2-4',
        status: 'search_team_review',
        occurredAt: '2026-08-30T10:05:00Z',
        actorUserId: 'user-rec-1',
        actorRoleLabel: 'Recruiter',
        note: 'Updated résumé received and accepted. Advanced to search-team review.',
        candidateVisible: true,
      },
      {
        id: 'ev-2-5',
        status: 'candidate_consent_required',
        occurredAt: '2026-08-31T11:00:00Z',
        actorUserId: 'user-rec-1',
        actorRoleLabel: 'Recruiter',
        note: 'Presentation authorization requested. Client identity is temporarily restricted; the reason is stated in the request.',
        candidateVisible: true,
      },
    ],
    createdAt: '2026-08-24T16:10:00Z',
    updatedAt: '2026-08-31T11:00:00Z',
  },
  {
    id: 'app-3',
    reference: 'APP-2026-1877',
    opportunityId: 'opp-4',
    candidateProfileId: 'cand-3',
    status: 'under_preliminary_review',
    submittedAt: '2026-08-29T09:15:00Z',
    resumeDocumentId: 'doc-6',
    screeningAnswers: [
      {
        questionId: 'q1',
        answer:
          'Two current directorships. One requires six board meetings and four audit committee meetings annually; the other requires four board meetings. Combined commitment is approximately thirty days per year, leaving capacity for a committee chair role.',
      },
      {
        questionId: 'q2',
        answer:
          'No relationship with any private-equity sponsor. One of my current directorships is at a technology business in an adjacent but non-competing market; details provided for the committee to assess.',
      },
      { questionId: 'q3', answer: 'Yes' },
    ],
    compensationAlignmentConfirmed: true,
    locationAlignmentConfirmed: true,
    internalReviewConsentAt: '2026-08-29T09:14:00Z',
    events: [
      {
        id: 'ev-3-1',
        status: 'submitted',
        occurredAt: '2026-08-29T09:15:00Z',
        actorUserId: 'user-cand-3',
        actorRoleLabel: 'Candidate',
        note: 'Application submitted. Reference APP-2026-1877 issued.',
        candidateVisible: true,
      },
      {
        id: 'ev-3-2',
        status: 'under_preliminary_review',
        occurredAt: '2026-08-31T08:30:00Z',
        actorUserId: 'user-rec-2',
        actorRoleLabel: 'Recruiter',
        note: 'Preliminary review opened. Independence review in progress.',
        candidateVisible: true,
      },
    ],
    createdAt: '2026-08-29T08:52:00Z',
    updatedAt: '2026-08-31T08:30:00Z',
  },
  {
    id: 'app-4',
    reference: 'APP-2026-1802',
    opportunityId: 'opp-3',
    candidateProfileId: 'cand-5',
    status: 'client_review',
    submittedAt: '2026-08-14T11:20:00Z',
    resumeDocumentId: 'doc-8',
    screeningAnswers: [
      {
        questionId: 'q1',
        answer:
          'I presented a quantified view of third-party concentration risk to the board risk committee six weeks before a supplier incident. The committee had previously declined funding to remediate it. I set out the exposure in loss terms and the specific scenarios. The funding decision was reversed, though not before the incident occurred.',
      },
      { questionId: 'q2', answer: 'Yes' },
    ],
    compensationAlignmentConfirmed: true,
    locationAlignmentConfirmed: true,
    internalReviewConsentAt: '2026-08-14T11:19:00Z',
    events: [
      {
        id: 'ev-4-1',
        status: 'submitted',
        occurredAt: '2026-08-14T11:20:00Z',
        actorUserId: 'user-cand-5',
        actorRoleLabel: 'Candidate',
        note: 'Application submitted. Reference APP-2026-1802 issued.',
        candidateVisible: true,
      },
      {
        id: 'ev-4-2',
        status: 'under_preliminary_review',
        occurredAt: '2026-08-15T09:00:00Z',
        actorUserId: 'user-rec-2',
        actorRoleLabel: 'Recruiter',
        note: 'Preliminary review opened.',
        candidateVisible: true,
      },
      {
        id: 'ev-4-3',
        status: 'search_team_review',
        occurredAt: '2026-08-18T14:30:00Z',
        actorUserId: 'user-rec-2',
        actorRoleLabel: 'Recruiter',
        note: 'Structured assessment completed by two consultants. Advanced to search-team review.',
        candidateVisible: true,
      },
      {
        id: 'ev-4-4',
        status: 'candidate_consent_required',
        occurredAt: '2026-08-20T09:00:00Z',
        actorUserId: 'user-rec-2',
        actorRoleLabel: 'Recruiter',
        note: 'Presentation authorization requested, naming the client.',
        candidateVisible: true,
      },
      {
        id: 'ev-4-5',
        status: 'presented_to_client',
        occurredAt: '2026-08-21T08:30:00Z',
        actorUserId: 'user-rec-2',
        actorRoleLabel: 'Recruiter',
        note: 'Presented following recorded authorization.',
        candidateVisible: true,
      },
      {
        id: 'ev-4-6',
        status: 'client_review',
        occurredAt: '2026-08-29T11:05:00Z',
        actorUserId: 'user-rec-2',
        actorRoleLabel: 'Recruiter',
        note: 'Client feedback received. Committee has asked to understand the first-year support structure before advancing.',
        candidateVisible: true,
      },
    ],
    createdAt: '2026-08-14T10:55:00Z',
    updatedAt: '2026-08-29T11:05:00Z',
  },
  {
    id: 'app-5',
    reference: 'APP-2026-1888',
    opportunityId: 'opp-5',
    candidateProfileId: 'cand-4',
    status: 'submitted',
    submittedAt: '2026-08-31T20:10:00Z',
    resumeDocumentId: 'doc-7',
    screeningAnswers: [
      {
        questionId: 'q1',
        answer:
          'Four acquired products onto one platform across three sites over twenty-two months. We protected delivery by freezing architecture changes on the two largest revenue products for the first two quarters and consolidating the smaller two first, which gave us a working pattern before we touched anything customers noticed.',
      },
      { questionId: 'q2', answer: 'Yes' },
    ],
    compensationAlignmentConfirmed: true,
    locationAlignmentConfirmed: true,
    internalReviewConsentAt: '2026-08-31T20:09:00Z',
    events: [
      {
        id: 'ev-5-1',
        status: 'submitted',
        occurredAt: '2026-08-31T20:10:00Z',
        actorUserId: 'user-cand-4',
        actorRoleLabel: 'Candidate',
        note: 'Application submitted. Reference APP-2026-1888 issued.',
        candidateVisible: true,
      },
    ],
    createdAt: '2026-08-31T19:50:00Z',
    updatedAt: '2026-08-31T20:10:00Z',
  },
  {
    id: 'app-6',
    reference: 'APP-2026-1855',
    opportunityId: 'opp-9',
    candidateProfileId: 'cand-6',
    status: 'on_hold',
    submittedAt: '2026-08-21T10:00:00Z',
    resumeDocumentId: 'doc-9',
    screeningAnswers: [
      {
        questionId: 'q1',
        answer:
          'I have not led a defense capture. My development leadership is in energy infrastructure, and I applied because the profit-and-loss scope and the government-customer dimension are comparable.',
      },
      { questionId: 'q2', answer: 'Prefer to discuss with the consultant' },
    ],
    compensationAlignmentConfirmed: true,
    locationAlignmentConfirmed: false,
    internalReviewConsentAt: '2026-08-21T09:59:00Z',
    events: [
      {
        id: 'ev-6-1',
        status: 'submitted',
        occurredAt: '2026-08-21T10:00:00Z',
        actorUserId: 'user-cand-6',
        actorRoleLabel: 'Candidate',
        note: 'Application submitted. Reference APP-2026-1855 issued.',
        candidateVisible: true,
      },
      {
        id: 'ev-6-2',
        status: 'under_preliminary_review',
        occurredAt: '2026-08-22T09:00:00Z',
        actorUserId: 'user-rec-1',
        actorRoleLabel: 'Recruiter',
        note: 'Preliminary review opened.',
        candidateVisible: true,
      },
      {
        id: 'ev-6-3',
        status: 'candidate_consent_required',
        occurredAt: '2026-08-26T13:00:00Z',
        actorUserId: 'user-rec-1',
        actorRoleLabel: 'Recruiter',
        note: 'Presentation authorization requested, naming the client.',
        candidateVisible: true,
      },
      {
        id: 'ev-6-4',
        status: 'on_hold',
        occurredAt: '2026-08-27T07:45:00Z',
        actorUserId: 'user-cand-6',
        actorRoleLabel: 'Candidate',
        note:
          'Candidate declined presentation authorization for this mandate. The application remains open and the candidacy is unaffected. Placed on hold pending a conversation about the location requirement.',
        candidateVisible: true,
      },
    ],
    createdAt: '2026-08-21T09:30:00Z',
    updatedAt: '2026-08-27T07:45:00Z',
  },
];

export const savedOpportunities: SavedOpportunity[] = [
  { id: 'saved-1', candidateProfileId: 'cand-1', opportunityId: 'opp-9', savedAt: '2026-08-23T18:00:00Z' },
  { id: 'saved-2', candidateProfileId: 'cand-1', opportunityId: 'opp-10', savedAt: '2026-08-26T20:15:00Z' },
  { id: 'saved-3', candidateProfileId: 'cand-2', opportunityId: 'opp-6', savedAt: '2026-08-30T21:00:00Z' },
  { id: 'saved-4', candidateProfileId: 'cand-4', opportunityId: 'opp-3', savedAt: '2026-08-29T22:30:00Z' },
];
